import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AllLeads } from '@core/models/all-leads.model';
import { Pagination } from '@core/models/pagination.model';
import { AuthHttpService } from '@core/services/auth-http.service';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { TransactionHttpService } from '@core/services/transaction-http.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import * as moment from 'moment-timezone';
import { Observable, of, Subscription, throwError } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { MemberInformationDialogComponent } from '../members/dialogs/member-information/member-information.component';
import { MemberDataService } from '../members/services/member-data.service';
import { AllLeadsAssignDialogComponent } from './dialogs/all-leads-assign/all-leads-assign.component';
import { AllLeadsCallLogComponent } from './dialogs/all-leads-call-log/all-leads-call-log.component';
import { AllLeadsImportDialogComponent } from './dialogs/all-leads-import/all-leads-import.component';
import { AffiliateSettingsDialogComponent } from './dialogs/affiliate-settings/affiliate-settings.component';
import { RemarkDialogComponent } from './dialogs/remark/remark.component';
import { ShowRemarkComponent } from './dialogs/show-remark/show-remark.component';
import { LeadHistoryComponent } from './dialogs/lead-history/lead-history.component';
import { AllLeadsDataService } from './services/all-leads-data.service';
import { AllLeadsEntityService } from './services/all-leads-entity.service';
import { CurrencyHttpService } from '@core/services/currency-http.service';
import { AppPermissionService } from '@core/services/app-permission.service';
import Swal from 'sweetalert2';
import { AppState } from '@store/reducers';
import { Store, select } from '@ngrx/store';
import { UndoLeadsDialogComponent } from './dialogs/undo-lead/undo-lead.component';
import { ReassignLeadsDialogComponent } from './dialogs/reassign-lead/reassign-lead.component';
import { ExtendLeadsDialogComponent } from './dialogs/extend-lead/extend-lead.component';
import { DateTime } from 'luxon';
import { AssignTargetDialogComponent } from './dialogs/assign-target/assign-target.component';

@Component({
  templateUrl: './all-leads.component.html',
  styleUrls: ['./all-leads.component.scss']
})
export class AllLeadsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('textArea', { read: ElementRef }) textArea: ElementRef;
  form: FormGroup;
  tz: any;
  todayDate: any;
  dropdown = {
    currencies: JSON.parse(sessionStorage.getItem('currencies')) === null ? [] : JSON.parse(sessionStorage.getItem('currencies')),
    telemarketer: this.dropdownHttpService.telemarketer,
    // leadTypeCategory: this.dropdownHttpService.filterLeadTypeCategory,
    perPage: this.dropdownHttpService.perPage,
    statuses: [
      {
        name: 'Open', value: 8, checked: true
      },
      {
        name: 'Active', value: 1, checked: true
      },
      {
        name: 'Following Up', value: 9, checked: true
      },
      {
        name: 'Expired', value: 2, checked: false
      },
      {
        name: 'Closed', value: 0, checked: false
      },
      {
        name: 'Partially Closed', value: 3, checked: false
      },
      {
        name: 'Failed', value: 4, checked: false
      },
      {
        name: 'Pending Justification', value: 6, checked: false
      },
      {
        name: 'Rejected Justification', value: 7, checked: false
      },
    ],
    leadProgress: this.dropdownHttpService.filterLeadProgress,
    leadType: this.dropdownHttpService.filterLeadType,
    sourceType: this.dropdownHttpService.sourceTypes,
  };
  messages$ = this.AllLeadsDataService.messages$;
  data$ = this.AllLeadsDataService.data$;

  dropdownSettings = {};
  AllLeads$: Observable<AllLeads[]>;
  onSearch = false;
  loading = false;
  clearBtnLoading = false;
  searchBtnLoading = false;
  pagination: Pagination;
  maxSize = 5;
  pageSize = 30;
  page = 1;
  params = '';
  buttonLoading = false;
  currentContact = '';
  selectedContactType = 'Mobile';
  ranges: any;
  dateTimePickerLocale = this.transactionHttpService.dateTimePickerLocale;
  timezone = JSON.parse(localStorage.getItem('user_data')).timezone;
  searchStatus = [1, 8, 9];
  searchProgressStatus = [];
  totalAssignedLeads = 0;
  totalUnassignedLeads = 0;
  selectedLeadType = null;

  default_sort_by = 'lead_id';
  default_sort_order = 'desc';

  sortingConfig = {
    'lead_assigned_date': 'desc',
    'lead_id': 'desc',
    'username': 'desc',
    'name': 'desc',
    'mobile': 'desc',
    'source_type': 'desc',
    'source_account': 'desc',
    'campaign': 'desc',
    'currency': 'desc',
    'last_call_attempt': 'desc',
    'status': 'desc',
    'registration_created_at': 'desc',
    'last_login': 'desc',
    'last_deposit_date': 'desc',
    'password': 'desc',
    'remarks': 'desc',
    'lead_type': 'desc',
    'lead_expired_date': 'desc',
    'last_follow_up_date': 'desc',
    'telemarketer': 'desc',
    'created_at': 'desc',
    'updated_at': 'desc',
  };
  sortingSelection = {
    'sort_by': this.default_sort_by,
    'sort_order': this.default_sort_order
  };
  dataLength: number;
  isAdmin: boolean = JSON.parse(localStorage.getItem('user_data')).is_admin;

  // permissions
  // allLeadsUseNewPermissions: boolean;
  canViewMemberDialog: boolean;
  canViewRemarkHistory: boolean;
  canAssignLeads: boolean;
  canExtendLeads: boolean;
  canViewCallLogsAttempts: boolean;
  canEditRemark: boolean;
  canViewLeadJustification: boolean;
  canEditLeadJustification: boolean;
  canViewAffiliateSettings: boolean;
  canImportLeads: boolean;
  canExportLeads: boolean;
  canReassignLeads: boolean;
  canUndoLeads: boolean;
  canViewLeadHistory: boolean;

  private subscription = new Subscription();
  private subscriptions = new Subscription();
  private refreshSubcription = new Subscription();

  constructor(
    public loadingBar: LoadingBarService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private AllLeadsDataService: AllLeadsDataService,
    private memberDataService: MemberDataService,
    private dropdownHttpService: DropdownHttpService,
    private transactionHttpService: TransactionHttpService,
    private eventEmitterService: EventEmitterService,
    private authHttpService: AuthHttpService,
    private allLeadsEntityService: AllLeadsEntityService,
    private currencyHttpService: CurrencyHttpService,
    private appPermissionService: AppPermissionService,
    private store: Store<AppState>,
  ) { }

  ngOnInit() {
    this.tz = JSON.parse(localStorage.getItem('user_data')).timezone;
    this.todayDate = DateTime.now().setZone(this.tz);
    this.setCurrencyDropdown();
    this.formInit();
    this.pagination = this.AllLeadsDataService.pagination;
    this.dropdownSettings = {
      singleSelection: true,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'username',
      labelKey: 'username',
      lazyLoading: true,
      noDataLabel: '',
      showCheckbox: false
    };
    this.ranges = this.transactionHttpService.ranges;

    const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
      this.canViewMemberDialog = appPermissions.all_leads_view_member_dialog;
      this.canViewRemarkHistory = appPermissions.view_remark_history;
      this.canAssignLeads = appPermissions.assign_leads;
      this.canExtendLeads = appPermissions.extend_leads;
      this.canViewCallLogsAttempts = appPermissions.view_call_logs_attempts;
      this.canEditRemark = appPermissions.add_remark;
      this.canViewLeadJustification = appPermissions.view_lead_justification;
      this.canEditLeadJustification = appPermissions.review_lead_justification;
      this.canViewAffiliateSettings = appPermissions.view_affiliate_settings;
      this.canImportLeads = appPermissions.import_leads;
      this.canExportLeads = appPermissions.export_all_leads_list;
      this.canReassignLeads = appPermissions.reassign_leads;
      this.canUndoLeads = appPermissions.undo_leads;
      this.canViewLeadHistory = appPermissions.view_lead_history
    });

    this.subscriptions.add(apSub);
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptions.unsubscribe();
    this.refreshSubcription.unsubscribe();
  }

  onSortColumn(property: string) {

    // Reset other columns
    for (const key in this.sortingConfig) {
      if (Object.prototype.hasOwnProperty.call(this.sortingConfig, key)) {
        if (key == property) {
          this.sortingConfig[key] = this.sortingConfig[key] === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortingConfig[key] = 'desc';
        }
      }
    }
    this.sortingSelection.sort_by = property;
    this.sortingSelection.sort_order = this.sortingConfig[property];
    this.onViewPageBy(this.page, this.pageSize, this.params);
  }

  onChangeStatus(event: any, id: number, ind: number) {
    const position = this.searchStatus.indexOf(id);
    if (event.target.checked) {
      this.searchStatus.push(id);
      this.dropdown.statuses[ind].checked = true;
    } else {
      this.searchStatus.splice(position, 1);
      this.dropdown.statuses[ind].checked = false;
    }
    this.form.patchValue({ status: this.searchStatus });
  }

  onChangeProgressStatus(event: any, id: number, ind: number) {
    const position = this.searchProgressStatus.indexOf(id);
    if (event.target.checked) {
      this.searchProgressStatus.push(id);
      this.dropdown.leadProgress[ind].checked = true;
    } else {
      this.searchProgressStatus.splice(position, 1);
      this.dropdown.leadProgress[ind].checked = false;
    }
    this.form.patchValue({ progress_status: this.searchProgressStatus });
  }

  onSubmit(clearSearch?: boolean) {
    this.timezone = JSON.parse(localStorage.getItem('user_data')).timezone;
    this.searchBtnLoading = clearSearch ? false : true;
    of(this.form.value)
      .pipe(
        map(this.filterFormFields),
        tap((data) => {
          if (data['start_date']) {
            data['start_date'] = moment(data['start_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
            data['end_date'] = moment(data['end_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
          }

          this.params = Object.keys(data)
            .map((key) => key + "=" + data[key])
            .join("&");
          const statusParams = this.generateStatusParams();
          const progressStatusParams = this.generateProgressStatusParams();
          this.params = this.params.replace(statusParams.oldStatusParams, statusParams.newStatusParams);
          this.params = this.params.replace(progressStatusParams.oldProgressStatusParams, progressStatusParams.newProgressStatusParams);
          this.sortingConfig[this.sortingSelection.sort_by] = 'desc';
          this.sortingSelection.sort_by = this.default_sort_by;
          this.sortingSelection.sort_order = this.default_sort_order;
          this.sortingConfig[this.default_sort_by] = this.default_sort_order;
          this.page = 1;
          this.onViewPageBy();
        })
      )
      .subscribe();
  }

  onViewPageBy(page = 1, pageSize?: number, params?: string) {
    this.loading = true;
    pageSize = this.pageSize;
    params = this.params ? `&${this.params}` : "";
    this.loadingBar.start();
    return (this.AllLeads$ = this.AllLeadsDataService
      .getWithQuery(`?page=${page}&perPage=${pageSize}${params}&${this.generateSortingParam()}`)
      .pipe(
        tap(res => {
          this.dataLength = res.length;
          this.pagination = this.AllLeadsDataService.pagination;
          this.loadingBar.complete();
          this.onSearch = true;
          this.loading = false;
          this.clearBtnLoading = false;
          this.searchBtnLoading = false;
          this.totalAssignedLeads = this.AllLeadsDataService.totalAssignedLeads;
          this.totalUnassignedLeads = this.AllLeadsDataService.totalUnassignedLeads;
        }),
        catchError((err) => {
          this.dataLength = 0;
          this.loading = false;
          this.clearBtnLoading = false;
          this.searchBtnLoading = false;
          this.loadingBar.complete();
          return throwError(err);
        })
      ));
  }

  onPerPage(size: Event) {
    this.pageSize = +(size.target as HTMLSelectElement).value;
    this.onViewPageBy(this.page, this.pageSize, this.params);
  }

  onExport() {
    this.timezone = JSON.parse(localStorage.getItem('user_data')).timezone;
    this.buttonLoading = true;
    of(this.form.value).pipe(
      map(this.filterFormFields),
      exhaustMap((data) => {
        if (data['start_date']) {
          data['start_date'] = moment(data['start_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
          data['end_date'] = moment(data['end_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
        }

        data['paginate'] = false;
        data['timezone'] = this.timezone;

        this.params = Object.keys(data).map(key => key + '=' + data[key]).join('&');
        const statusParams = this.generateStatusParams();
        const progressStatusParams = this.generateProgressStatusParams();
        this.params = this.params.replace(statusParams.oldStatusParams, statusParams.newStatusParams);
        this.params = this.params.replace(progressStatusParams.oldProgressStatusParams, progressStatusParams.newProgressStatusParams);
        const parameters = this.params ? `${this.params}` : '';
        this.loadingBar.start();
        return this.AllLeadsDataService.exportReport(`?${parameters}&${this.generateSortingParam()}`).pipe(
          tap(res => {
            this.loadingBar.complete();
            this.buttonLoading = false;
          }),
          catchError(err => {
            this.loadingBar.complete();
            this.buttonLoading = false;
            return throwError(err);
          })
        );
      }),
    ).subscribe();
  }

  updateDateRange() {
    this.ranges = this.transactionHttpService.updateDateRange();
  }

  private generateStatusParams() {
    return {
      newStatusParams: Object.keys(this.searchStatus).map(key => `status[${key}]=${this.searchStatus[key]}`).join('&'),
      oldStatusParams: 'status=' + Object.keys(this.searchStatus).map(key => this.searchStatus[key]).join(','),
    };
  }

  private generateProgressStatusParams() {
    return {
      newProgressStatusParams: Object.keys(this.searchProgressStatus).map(key => `progress_status[${key}]=${this.searchProgressStatus[key]}`).join('&'),
      oldProgressStatusParams: 'progress_status=' + Object.keys(this.searchProgressStatus).map(key => this.searchProgressStatus[key]).join(','),
    };
  }

  onOpenDialog(type: string, id?: number, data?: any, option?: any, status?: any) {
    if (type === 'member-information') {
      if (!this.canViewMemberDialog) {
        Swal.fire('Permission Error', 'You do not have permission to view member information', 'error');
        return;
      }

      this.subscription = this.memberDataService.getById(id, `?start_date=${moment(this.transactionHttpService.getYesterday().from).tz(this.timezone, true).utc().format("YYYY-MM-DD HH:mm:ss")}
      &end_date=${moment(this.transactionHttpService.getLast24Hours().to).tz(this.timezone, true).utc().format("YYYY-MM-DD HH:mm:ss")}&additional_info=1`).pipe(
        tap((res) => {
          if (res) {
            this.openDialogBy(MemberInformationDialogComponent, { mode: type, member: res });
          }
        })
      ).subscribe();
    } else if (type === 'callLog') {
      this.openDialogBy(AllLeadsCallLogComponent, { mode: type, callLog: data, status: status });
    } else if (type === 'remarks') {
      this.openDialogBy(RemarkDialogComponent, { mode: type, leadID: data, status: status});
    } else if (type === 'show-remarks') {
      // for Lead Justification
      if (option == 'lead_justification' && !this.canViewLeadJustification) {
        Swal.fire('Permission Error', 'You do not have permission to view lead justification', 'error');
        return;
      }

      // For Remark History
      if (option == 'remark_history' && !this.canViewRemarkHistory) {
        Swal.fire('Permission Error', 'You do not have permission to view remark history', 'error');
        return;
      }

      option == 'lead_justification' ? this.openDialogBy(ShowRemarkComponent, { mode: type, leadID: data, leadJustification: option, status: status}) : this.openDialogBy(ShowRemarkComponent, { mode: type, leadID: data, status: status });
    } else if (type === 'importLead') {
      this.openDialogBy(AllLeadsImportDialogComponent, { mode: type });
    } else if ( type === 'affiliateSettings') {
      this.openDialogBy(AffiliateSettingsDialogComponent, { mode: type });
    } else if ( type === 'undoLead') {
      this.openDialogBy(UndoLeadsDialogComponent, { mode: type });
    } else if ( type === 'reassignLead') {
      this.openDialogBy(ReassignLeadsDialogComponent, { mode: type });
    } else if ( type === 'extendLead') {
      this.openDialogBy(ExtendLeadsDialogComponent, { mode: type, leadID: data });
    } else if ( type === 'leadHistory') {
      this.openDialogBy(LeadHistoryComponent, { mode: type, leadID: data });
    } else if (type === 'assignLeadTarget') {
      this.openDialogBy(AssignTargetDialogComponent, { mode: type, leadID: data });
    }
    else {
      this.openDialogBy(AllLeadsAssignDialogComponent, { mode: type });
    }
  }

  private openDialogBy(componentRef: any, data?: { mode?: any, member?: any, callLog?: any, leadID?: any, leadJustification?: any, status?: any}) {
    const dialogRef = this.dialog.open(componentRef, {
      width: data.mode === 'undoLead' || data.mode === 'reassignLead' || data.mode === 'callLog' || data.mode === 'importLead' || data.mode === 'remarks' || data.mode === 'affiliateSettings' ? '800px' : data.mode === 'assignLead' || data.mode === 'extendLead' || data.mode === 'reassignLead' ? '1000px' : '1500px',
      height: data.mode === 'undoLead' || data.mode === 'assignLead' || data.mode === 'reassignLead' || data.mode === 'callLog' || data.mode === 'importLead' || data.mode === 'remarks' || data.mode === 'show-remarks' || data.mode === 'affiliateSettings' || data.mode === 'leadHistory' || data.mode === 'assignLeadTarget' ? 'auto' : data.mode === 'extendLead' ? '50vh' : '80vh',
      data: {
        member: data.member,
        callLog: data.callLog,
        leadID: data.leadID,
        leadJustification: data.leadJustification,
        status: data.status
      },
      autoFocus: false
    });

    if (data.mode === 'undoLead' || data.mode === 'reassignLead' || data.mode === 'extendLead' || data.mode === 'assignLead' || data.mode === 'remarks' || data.mode === 'show-remarks' || data.mode === 'callLog' || data.mode === 'importLead' || data.mode === 'assignLeadTarget') {
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          if (data.mode === 'importLead') {
            this.page = 1;
          }
          
          this.onViewPageBy(this.page);
        }
      });
    }
  }

  onClear() {
    this.clearBtnLoading = true;
    this.eventEmitterService.onClearMemberSearch();
    this.selectedContactType = 'Mobile';
    this.searchStatus = [1, 8, 9];
    this.searchProgressStatus = [];
    this.dropdown.statuses.forEach((child) => {
      if (child.name === 'Active' || child.name === 'Open' || child.name === 'Following Up') {
        child.checked = true;
      } else {
        child.checked = false;
      }
    });
    this.dropdown.leadProgress.forEach((child) => {
      child.checked = false;
    });
    this.form.patchValue({
      username: null,
      name: null,
      id: null,
      currency_id: 'all',
      telemarketer: null,
      mobile: null,
      email: null,
      no_deposit: null,
      date_type: 'registration_date',
      start_date: null,
      end_date: null,
      defaultDate: null,
      contactType: 'Mobile',
      status: this.searchStatus,
      progress_status: this.searchProgressStatus,
      lead_type: null,
      lead_category: null,
      source_type: null,
      source_account: null,
      campaign_name: null,
      campaign_code: null,
      dummy: 1
    })
    this.form.controls.source_account.disable();
    this.cdr.detectChanges();
    this.onSubmit(true);
  }

  onContactType(label: string) {
    this.selectedContactType = label;
    this.contactChanges();
    this.cdr.detectChanges();
  }

  onContact(event: Event) {
    this.currentContact = (event.target as HTMLInputElement).value;
    this.contactChanges();
    this.cdr.detectChanges();
  }

  private contactChanges() {
    if (this.selectedContactType !== '' || this.selectedContactType !== null) {

      if (this.selectedContactType === 'Mobile') {
        this.form.patchValue({
          [this.selectedContactType.toLocaleLowerCase()]: this.currentContact,
          email: null,
        });
      }
      if (this.selectedContactType === 'Email') {
        this.form.patchValue({
          mobile: null,
          [this.selectedContactType.toLocaleLowerCase()]: this.currentContact,
        });
      }
    }
  }

  onClearDate() {
    if (this.form.value.start_date !== null) {
      this.form.patchValue({ defaultDate: null });
    }
  }

  onDateRange(event: any) {
    if (event) {
      this.form.patchValue({
        start_date: event.startDate !== null && event.startDate !== undefined ? event.startDate : null,
        end_date: event.endDate !== null && event.endDate !== undefined ? event.endDate : null
      });
    }
  }

  toLowerCaseInput(controlName: string, event: Event) {
    this.authHttpService.forceLowerCaseInputControl(this.form, controlName, event);
  }

  private setCurrencyDropdown() {
    if (this.dropdown.currencies.length === 0) {
      // set interval to get currencies from sessionStorage, to prevent returning empty currency dropdown
      if (sessionStorage.getItem('currencies') != undefined && sessionStorage.getItem('currencies') != null && sessionStorage.getItem('currencies') !== '') {
        var interval = setInterval(() => {
          this.dropdown.currencies = JSON.parse(sessionStorage.getItem('currencies'));
          if (this.dropdown.currencies != null) {
            clearInterval(interval);
          }
        }, 100);
      } else {
        this.currencyHttpService.setCurrency().subscribe(res => {
          this.dropdown.currencies = res;
        });
      }
    }
  }

  private generateSortingParam() {
    const sortingParams = Object.keys(this.sortingSelection).map(key => key + '=' + this.sortingSelection[key]).join('&');
    return sortingParams;
  }

  private convertDateTime(dateTime: any) {
    return moment(dateTime).tz(this.timezone, true).utc().format('YYYY-MM-DD');
  }

  private formInit() {
    this.form = new FormGroup({
      username: new FormControl(null),
      name: new FormControl(null),
      id: new FormControl(null),
      currency_id: new FormControl('all'),
      telemarketer: new FormControl(null),
      mobile: new FormControl(null),
      email: new FormControl(null),
      no_deposit: new FormControl(null),
      date_type: new FormControl('registration_date'),
      start_date: new FormControl(null),
      end_date: new FormControl(null),
      defaultDate: new FormControl(null),
      contactType: new FormControl('Mobile'),
      status: new FormControl(this.searchStatus),
      progress_status: new FormControl(this.searchProgressStatus),
      lead_type: new FormControl(null),
      lead_category: new FormControl(null),
      source_type: new FormControl(null),
      source_account: new FormControl({value: null, disabled: true}),
      campaign_name: new FormControl(null),
      campaign_code: new FormControl(null),
      dummy: new FormControl(1),
    });

    this.form.get('lead_type').valueChanges.subscribe(res => {
      this.selectedLeadType = res;
      if (res == 3) {
        this.form.patchValue({
          lead_category: null
        })
      }
      else if (res == 1 || res == 2){
        this.form.patchValue({
          lead_category: 1
        })
      }      
    })
  }

  private filterFormFields(formData: any) {
    const fields = {};
    Object.keys(formData).forEach(key => {
      if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined && formData[key] !== false && key !== 'defaultDate' && key !== 'contactType') {
        fields[key] = formData[key];
      }
    });
    return fields;
  }

  getUrl(site: string) {
    let url = new URL(site);
    return url.host;
  }

  urlIsValid(url: string) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  onFileUpload(event: any) {
    const file: File = event.target.files[0];
    const formData = new FormData();
    formData.append('attached_file', file);
    this.loading = true;
    this.AllLeadsDataService.import(formData).pipe(
      tap((_) => {
        this.loading = false;
        this.onSubmit();
      })
    ).subscribe();
    event.target.value = '';
  }

  resetData() {
    this.loadingBar.complete();
    this.AllLeadsDataService.resetData();
  }

  onSelectSourceType(event: Event) {
    let selectedSourceType = (event.target as HTMLInputElement).value;
    if (selectedSourceType !== null && selectedSourceType !== 'null' && +selectedSourceType != 3) {
      this.form.controls.source_account.enable();
    } else {
      this.form.patchValue({source_account: null});
      this.form.controls.source_account.disable();
    }
  }

  calculateDayLeft(date: any){
    // Target date
    const targetDate = DateTime.fromISO(date, { zone: this.tz });

    // Check if the target date is today or in the past
    if (targetDate <= this.todayDate || targetDate.hasSame(this.todayDate, 'day')) {
      return 0;
    }

    // Calculate the difference in days
    const daysLeft = targetDate.startOf('day').diff(this.todayDate.startOf('day'), 'days').days;
    return daysLeft > 0 ? `${Math.ceil(daysLeft)}` : 0;
  }

  getRegisterStatus(id){
    if (id != null){
      return 1;
    }

    return 0;
  }

  getFTDStatus(last_deposit_date){
    if (last_deposit_date != null){
      return 1;
    }

    return 0;
  }

  onChangeDummy($event) {
    let isChecked = $event.target.checked ? 1 : 0;
    this.form.patchValue({
      dummy: isChecked
    });
  }
}
